import { useTranslation } from 'react-i18next';

import { Button } from '~/chords/Button';
import { env } from '~/lib/env';

export function FeedbackButton() {
  const { t } = useTranslation('wmgone', {
    keyPrefix: 'globalHeader',
  });

  const feedbackUrl = env('VITE_WMG_FEEDBACK_URL');

  return feedbackUrl ? (
    <Button variant="secondary" asChild>
      <a
        href={feedbackUrl}
        className="grid place-items-center"
        target="_blank"
        rel="noreferrer noopener"
      >
        {t('feedback.button')}
      </a>
    </Button>
  ) : null;
}

FeedbackButton.displayName = 'FeedbackButton';
